import type { AnimalWarning } from "@/api/types";
import "./AnimalWarnings.css";

/**
 * ef-059-6 — the Livestock page's Warnings region: the server's non-blocking findings from a
 * save that SUCCEEDED (today only `duplicate_tag`). Always mounted so the live region exists
 * before its first message (screen readers announce changes, not insertions); dismissible,
 * because the warning is information, never a gate.
 */
export function AnimalWarnings({ warnings, onDismiss }: { warnings: AnimalWarning[]; onDismiss: () => void }) {
  const has = warnings.length > 0;
  return (
    <div
      className="animal-warnings"
      role="status"
      aria-label="Warnings"
      data-state={has ? "ready" : "empty"}
    >
      {has && (
        <>
          <ul className="animal-warnings__list">
            {warnings.map((w, i) => (
              <li key={`${w.code}-${i}`}>{w.message}</li>
            ))}
          </ul>
          <button type="button" className="btn btn--ghost animal-warnings__dismiss" onClick={onDismiss}>
            Dismiss warnings
          </button>
        </>
      )}
    </div>
  );
}
